import { DownArrow } from 'assets'
import dayjs from 'dayjs'
import React, { useState } from 'react'
import { useEffect } from 'react'
import ReactApexChart from 'react-apexcharts'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getVideoLineChartAction } from 'store/action/videoReducer'
import { getEmotionFColor, getEmotionIcon, getEmotionSColor } from 'utils/getEmotionIcon'

function DVideoLineChart() {
   const videoRedux = useSelector((state) => state.videoRedux)
   const { loading, videoDetails, videoLineChartData, videoDetailsLoader } = videoRedux

   const settingData = useSelector((state) => state.settings)
   const { selectedChannelID } = settingData

   const dispatch = useDispatch()
   const [filterData, setFilterData] = useState([])

   useEffect(() => {
      if (videoDetails?.video_id && selectedChannelID && !videoDetailsLoader) {
         dispatch(
            getVideoLineChartAction({
               video_id: videoDetails?.video_id,
               channel_id: selectedChannelID,
               period_type: '5day'
            })
         )
      }
      return () => {}
   }, [videoDetails, videoDetailsLoader])

   const getTotalEmotionCounts = (data) => {
      const categories = ['positive', 'negative', 'neutral']

      return categories.flatMap((category) =>
         data[category].map((item) => ({
            emotion: item.emotion,
            total_count: item.total_count,
            type: category
         }))
      )
   }

   useEffect(() => {
      if (videoLineChartData) {
         const result = getTotalEmotionCounts(videoLineChartData)
         setFilterData(result)
      } else {
         setFilterData([])
      }
      return () => {}
   }, [videoLineChartData])

   // useEffect(() => {
   //    if (videoLineChartData) {
   //       const processedData = Object.entries(videoLineChartData).flatMap(([type, emotions]) =>
   //          emotions.flatMap((emotionData) =>
   //             emotionData.datewise_counts.map(({ date, count }) => ({
   //                name: emotionData.emotion,
   //                type,
   //                date,
   //                count
   //             }))
   //          )
   //       )
   //       setFilterData(processedData)
   //    } else {
   //       setFilterData([])
   //    }

   //    return () => {}
   // }, [videoLineChartData])

   return (
      <div className={`section-pdf ${videoLineChartData ? '' : ''}`} id="emotions-graph">
         <div
            className="chart-section"
            style={{ position: 'relative', width: '-webkit-fill-available' }}>
            <div className="card">
               <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 ">
                  <div>
                     <p className="at-text-dark at-font-20">Emotions</p>
                  </div>
               </div>

               <div>
                  {videoLineChartData && <VLineChart isActiveDate={'5day'} emotionType={'all'} />}
               </div>
               <div className="card p-0 overflow-hidden mt-3">
                  <table className="table mb-0  table-border">
                     <thead className="table-dark">
                        <tr>
                           <th>Emotion</th>
                           <th>Total Count</th>
                        </tr>
                     </thead>
                     <tbody>
                        {filterData.map((item, index) => (
                           <tr key={index}>
                              <td className="text-capitalize">{item.emotion}</td>
                              <td>{item.total_count}</td>
                           </tr>
                        ))}
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </div>
   )
}

export default DVideoLineChart

const getMergedEmotionData = (
   selection,
   positive = [],
   negative = [],
   neutral = [],
   isActiveDate
) => {
   // Select the arrays based on the selection parameter
   let combinedData
   if (selection === 'all') {
      combinedData = [
         ...positive.map((item) => ({ ...item, type: 'positive' })),
         ...negative.map((item) => ({ ...item, type: 'negative' })),
         ...neutral.map((item) => ({ ...item, type: 'neutral' }))
      ]
   } else {
      return { result: [], labels: [] }
   }

   const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1)

   // Map each emotion and its counts
   const result = combinedData.map(({ emotion, datewise_counts }) => ({
      name: capitalize(emotion),
      data: datewise_counts.map(({ count }) => count)
   }))
   const type = combinedData.map(({ type }) => ({
      type: type
   }))
   const label = Array.from(
      new Set(
         combinedData.flatMap(({ datewise_counts }) => datewise_counts.map(({ date }) => date))
      )
   )

   return { result, label, type }
}

const VLineChart = ({ emotionType, isActiveDate }) => {
   const videoRedux = useSelector((state) => state.videoRedux)
   const { loading, videoDetails, videoLineChartData } = videoRedux

   const [series, setSeries] = useState([])
   const [labels, setLabels] = useState([])
   const [options, setOptions] = useState(null)
   const [visibleSeries, setVisibleSeries] = useState([])
   const [typeStore, setTypeStore] = useState(null)

   useEffect(() => {
      if (videoDetails) {
         const mergedData = getMergedEmotionData(
            emotionType,
            videoLineChartData?.positive,
            videoLineChartData?.negative,
            videoLineChartData?.neutral,
            isActiveDate
         )

         if (mergedData) {
            const gradientColors = { start: [], end: [] }

            mergedData.result?.forEach((item, i) => {
               const emotionName = item?.name
               const emotionType = mergedData?.type[i]
               gradientColors.start.push(getEmotionFColor(emotionName, emotionType.type))
               gradientColors.end.push(getEmotionSColor(emotionName, emotionType.type))
            })

            setOptions({
               fill: {
                  type: 'gradient',
                  gradient: {
                     shade: 'dark',
                     type: 'horizontal',
                     shadeIntensity: 0.5,
                     gradientToColors: gradientColors.end,
                     inverseColors: false,
                     opacityFrom: 0.9,
                     opacityTo: 0.5,
                     stops: [0, 100]
                  }
               },
               colors: gradientColors.start,
               chart: {
                  type: 'line',
                  height: 350,
                  zoom: { enabled: false },
                  toolbar: { show: false },
                  foreColor: '#fff'
               },
               stroke: {
                  curve: 'smooth',
                  width: 2
               },
               dataLabels: {
                  enabled: true,
                  style: {
                     fontSize: '10px',
                     fontWeight: 'bold',
                     colors: undefined
                  },
                  background: {
                     enabled: true,
                     foreColor: '#000'
                  }
               },
               markers: { hover: { sizeOffset: 4 } },
               legend: { show: false }, // Turn off the default legend
               grid: { show: false },
               tooltip: { enabled: true, theme: 'dark' },
               xaxis: {
                  categories: labels, // Ensure you pass the correct labels
                  labels: {
                     show: true,
                     rotate: -45, // Rotating labels to avoid overlap
                     // rotateAlways: true,
                     offsetX: 4, // Adjust if necessary
                     offsetY: 2 // Adjust the Y positioning to give space at the bottom
                  }
               }
            })
            setSeries(mergedData.result || [])
            setLabels(mergedData.label || [])
            setTypeStore(mergedData.type)
            setVisibleSeries(mergedData.result.map(() => true)) // Set all series visible initially
         }
      } else {
         setSeries([])
         setLabels([])
      }
   }, [emotionType, videoDetails, videoLineChartData])

   // Toggle visibility for a series
   const toggleSeriesVisibility = (index) => {
      setVisibleSeries((prev) => {
         const updated = [...prev]
         updated[index] = !updated[index]
         return updated
      })
   }

   return (
      <div>
         {options && series && (
            <>
               <div id="chart">
                  <ReactApexChart
                     options={{
                        ...options,
                        labels: labels || []
                     }}
                     series={series.map((s, i) => (visibleSeries[i] ? s : { ...s, data: [] }))}
                     height={350}
                  />
               </div>

               {/* Custom Legend */}
               <div className="custom-legend">
                  {series.map((item, index) => (
                     <div
                        className="custom-legend-wrap"
                        key={index}
                        onClick={() => toggleSeriesVisibility(index)}>
                        <div className="icon-wrap icon-emotion-chart">
                           {getEmotionIcon(item.name, typeStore[index]?.type)}
                        </div>
                        <span
                           className={`chart-emotion-name ${
                              visibleSeries[index] ? 'at-text-dark' : 'at-text-light'
                           }`}>
                           {item.name}
                        </span>
                        {/* <div className="icon-wrap">
                           <DownArrow />
                        </div> */}
                     </div>
                  ))}
               </div>
            </>
         )}
      </div>
   )
}
